import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b605322e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "balance"
}
const _hoisted_2 = { class: "amounts" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Solde Total", -1))
const _hoisted_4 = { class: "amount" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "amount" }

import { computed, ComputedRef, onMounted } from 'vue';
import { Card } from '@courseur/types';
import { currency } from '@courseur/utils';
import { useAuthStore, useCardsStore } from '@/stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'Balance',
  setup(__props) {

const authStore = useAuthStore()
const cardsStore = useCardsStore()

const balance: ComputedRef<number> = computed(() => {
    const totalCards = cardsStore.byName.reduce((acc: number, element: Card) => parseFloat(element.balance) + acc, 0);
    return parseFloat(authStore.user.agency.balance) + totalCards;
});

onMounted(() => {
    cardsStore.fetchCollection();
});


return (_ctx: any,_cache: any) => {
  return (_unref(authStore).user.agency)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_unref(currency)(balance.value)) + " ", 1),
              _hoisted_5
            ])
          ]),
          _createElementVNode("div", null, [
            _createTextVNode(" Solde Allouable "),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_unref(currency)(_unref(authStore).user.agency.balance)), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})